import { useState } from 'react';
import { Services } from '../../../Services';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert"
import dashboardclasses from '../../dashboard.module.css'
const UseDataApi = () => {

  const Navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = { Authorization: `token ${sessionStorage.getItem("token")}` };


  const fetchData = async (id) => {
    Services.GetvendorDetails("GET", null, token, id)
      .then((res) => {
        setLoading(false);
        console.log(res);
        if (res.Status === 1) {
          setData({ Vendors: res.Vendors, Documents: res.Documents, Subcategories: res.Subcategories, WalletTransactions: res.WalletTransactions });
        } else if (res.Status === 0) {
          toast.error(`${res.Message}`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if (res.Message === "Token expired") {
            Navigate("/");
          }
        }
      })
      .catch((err) => {
        // alert(err);
        alert("something went wrong please try again");
        console.log(err);
      });
  };



  const deleteDocData = async (id, name) => {
    swal(`Are You sure you want to Delete ${name}?`, {
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: "Cancel",
        catch: {
          text: "Delete",
          value: "Delete",
          className: dashboardclasses["cancel-delete"],
        },
        defeat: false,
      },
    }).then((value) => {
      switch (value) {
        case "Delete":
          Services.VendorDocDelete("Delete", null, token, id)
            .then((res) => {
              setLoading(false);
              console.log(res);
              if (res.Status === 1) {
                setData(prev => {
                  console.log(prev)
                  return { Vendors: prev.Vendors, Documents: prev.Documents.filter(item => item._id != id), Subcategories: prev.Subcategories }

                });
                toast.success(`${res.Message}`, {
                  position: "top-center",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } else if (res.Status === 0) {
                toast.error(`${res.Message}`, {
                  position: "top-center",
                  autoClose: 1000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                if (res.Message === "Token expired") {
                  Navigate("/");
                }
              }
            })
            .catch((err) => {
              // alert(err);
              alert("something went wrong please try again");
              console.log(err);
            });
          break;

        // default:
        //     swal("Got away safely!");
      }
    });

  };

  const updateVendorDocs = async (id, setData) => {
    //
    let status = { status: 'Approved' }
    Services.ApproveVendorDocs("PUT", JSON.stringify(status), token, id)
      .then((res) => {
        setLoading(false);
        console.log(res);
        if (res.Status === 1) {
          setData(prev => {
            console.log(prev)
            let newData = prev.Documents.filter(item => item._id == id)
            newData = { ...newData[0], status: "Approved" }
            console.log(newData)
            return { Vendors: prev.Vendors, Documents: [...prev.Documents.filter(item => item._id != id), newData], Subcategories: prev.Subcategories }

          });
          toast.success(`${res.Message}`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (res.Status === 0) {
          toast.error(`${res.Message}`, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          if (res.Message === "Token expired") {
            Navigate("/");
          }
        }
      })
      .catch((err) => {
        // alert(err);
        alert("something went wrong please try again");
        console.log(err);
      });
  }

  return { data, loading, error, deleteDocData, fetchData, updateVendorDocs, setData };
};

export default UseDataApi;